import { Stack } from '@mui/material';
import React from 'react';

import {
  CardHeader,
  CardRow,
  CardRows,
  StyledCard,
  Title,
} from '@/console/features/card-layout/components/card/card.styled';
import { TCardProps } from '@/console/features/card-layout/components/card/card.types';
import { EmptyCard } from '@/console/features/card-layout/components/empty-card/empty-card';
import { useCard } from '@/console/features/card-layout/hooks/use-card/use-card';
import { MoreHorizIcon } from '@/shared/assets/icons/more-horiz-icon';
import { IconButton } from '@/shared/components/ui/button/icon-button/icon-button';
import { OverlayLoader } from '@/shared/components/ui/overlay-loader/overlay-loader';
import { PopoverController } from '@/shared/components/ui/popover/components/popover-controller/popover-controller';
import { PopoverOptions } from '@/shared/components/ui/popover/components/popover-options/popover-options.styled';

export const Card = <T,>({
  title,
  popoverContent,
  row,
  emptyCard,
  showLoader,
  data,
  ...rest
}: TCardProps<T>) => {
  const { cardRef, headerRef, cardRowsHeight } = useCard();

  return (
    <StyledCard ref={cardRef} {...rest}>
      <CardHeader ref={headerRef}>
        <Stack direction="row" alignItems="center" gap="0.5rem">
          <Title variant="h5">{title}</Title>
        </Stack>
        <PopoverController
          trigger={
            <IconButton variant="primary">
              <MoreHorizIcon />
            </IconButton>
          }
        >
          {() => {
            return (
              <PopoverOptions>
                {popoverContent && popoverContent}
              </PopoverOptions>
            );
          }}
        </PopoverController>
      </CardHeader>
      <Stack
        justifyContent={data?.length === 0 ? 'center' : ''}
        height={cardRowsHeight ?? '100%'}
        overflow="auto"
      >
        <OverlayLoader display={showLoader} />
        {data?.length === 0 && <EmptyCard {...emptyCard} />}
        <CardRows>
          {data?.map((item, index) => (
            <CardRow key={index}>{row(item)}</CardRow>
          ))}
        </CardRows>
      </Stack>
    </StyledCard>
  );
};
